<template>
  <div id="product">
    <SfBreadcrumbs @click="breadClicked" class="breadcrumbs desktop-only" :breadcrumbs="breadcrumbs" />
    <div class="product">
      <div class="gallery">
        <SfGallery :images="product.images" enableZoom ref="gallery" />
      </div>
      <div class="product__info">
        <div class="product__header">
          <SfHeading :title="product.name" :level="3" class="sf-heading--no-underline sf-heading--left" />
          <SfIcon icon="drag" size="xl" color="gray-secondary" class="product__drag-icon mobile-only" />
        </div>
        <div class="product__price-and-rating">
          <SfPrice :regular="product.price" />
        </div>
        <div>
          <p class="product__description">{{ product.description }}</p>
          <SfSelect v-model="selectedSize" label="Taille" class="sf-select--underlined product__select-size" :key="selectKey">
            <SfSelectOption v-for="(size, key) in product.sizes" :key="key" :value="size">
              <SfProductOption :label="size"></SfProductOption>
            </SfSelectOption>
          </SfSelect>
          <div class="product__colors">
            <p class="product__color-label">Couleur :</p>
            <SfColor
              v-for="(color, i) in product.colors"
              :key="i"
              :color="color.color"
              :selected="color.selected"
              class="product__color"
              @click="selectColor(i)"
            />
          </div>
          <SfAddToCart v-model="qty" class="product__add-to-cart">
            <SfButton slot="add-to-cart-btn" class="sf-add-to-cart__button" @click="addToCart">Passer une Commande</SfButton>
          </SfAddToCart>
        </div>
        <SfTabs :open-tab="1" class="product__tabs">
          <SfTab v-if="product.information" title="Informations additionelles">{{ product.information }}</SfTab>
        </SfTabs>
      </div>
    </div>
  </div>
</template>
<script>
import {
  SfGallery,
  SfHeading,
  SfPrice,
  SfRating,
  SfIcon,
  SfTabs,
  SfProperty,
  SfButton,
  SfReview,
  SfAddToCart,
  SfColor,
  SfSelect,
  SfProductOption,
  SfBreadcrumbs
} from "@storefront-ui/vue";
import axios from "axios";

const imageDefault = [
  { desktop: { url: "" }, mobile: { url: "" } },
  { desktop: { url: "" }, mobile: { url: "" } },
  { desktop: { url: "" }, mobile: { url: "" } },
  { desktop: { url: "" }, mobile: { url: "" } }
];
export default {
  name: "Product",
  components: {
    SfGallery,
    SfHeading,
    SfPrice,
    SfRating,
    SfIcon,
    SfTabs,
    SfProperty,
    SfButton,
    SfReview,
    SfAddToCart,
    SfColor,
    SfSelect,
    SfProductOption,
    SfBreadcrumbs
  },
  created() {
    axios
      .get("/api/get-products", {
        params: {
          refFilter: this.$route.query.ref
        }
      })
      .then(ret => {
        this.product = ret.data.products[0];
        this.selectKey += 1;
        this.product.images = imageDefault;
        this.product.name = this.product.title;

        axios.get("/static/p/" + this.$route.query.ref).then(r => {
          let images = [];
          r.data.map((url, i) => {
            images.push({
              desktop: { url: "/" + url },
              mobile: {
                url: "/" + url
              }
            });
          });
          this.product.images = images;
          this.product.name = this.product.title;
          this.breadcrumbs = [
            {
              text: "Accueil",
              route: {
                link: "/category"
              }
            },
            {
              text: this.product.category,
              route: {
                link: `/category?cat=${this.product.category}`
              }
            },
            {
              text: this.product.title
            }
          ];
        });
      })
      .catch(err => {
        console.error(err);
      });
  },
  mounted() {
    this.$nextTick(() => {
      window.dispatchEvent(new Event("resize"));
    });
  },
  data() {
    return {
      current: 1,
      selectedColor: "",
      selectedSize: "",
      selectKey: 0,
      qty: 1,
      gKey: 2,
      product: {
        name: "Cashmere Sweater",
        description:
          "Find stunning women cocktail and party dresses. Stand out in lace and metallic cocktail dresses and party dresses from all your favorite brands.",
        images: imageDefault,
        price: "$50.00",
        colors: [
          {
            color: "#EDCBB9",
            name: "beige",
            selected: true
          },
          {
            color: "#ABD9D8",
            name: "mint1",
            selected: false
          }
        ],
        rating: {
          rate: 4,
          max: 5
        },
        details: [
          {
            name: "Code",
            value: 435435
          },
          {
            name: "Material",
            value: "Cotton"
          },
          {
            name: "Category",
            value: "Pants"
          },
          {
            name: "Country",
            value: "Poland"
          }
        ],
        sizes: [],
        brand:
          "Brand name is the perfect pairing of quality and design. This label creates major everyday vibes with its collection of modern brooches, silver and gold jewellery, or clips it back with hair accessories in geo styles.",
        reviews: [
          {
            author: "Jane D.Smith",
            date: "April 2019",
            message:
              "I was looking for a bright light for the kitchen but wanted some item more modern than a strip light. this one is perfect, very bright and looks great. I can comment on interlation as I had an electrition instal it. Would recommend.",
            rating: {
              max: 5,
              rate: 4
            }
          },
          {
            author: "Jane D.Smith",
            date: "April 2019",
            message:
              "I was looking for a bright light for the kitchen but wanted some item more modern than a strip light. this one is perfect, very bright and looks great. I can comment on interlation as I had an electrition instal it. Would recommend.",
            rating: {
              max: 5,
              rate: 4
            }
          }
        ]
      },
      selected: false,
      breadcrumbs: []
    };
  },
  methods: {
    breadClicked(route) {
      this.$router.push(route.link);
    },
    addToCart() {
      const subject = `Commande Fêt'Art`;
      const email = "fetartboutique" + "" + "@hotmail.com";
      const order = `${this.qty} x ${this.product.name} #ref: ${this.product.ref} (size: ${this.selectedSize}, color: ${this.selectedColor})`;
      const message = `Bonjour Michèle, %0D%0A Je voudrais commander l'article suivant: %0D%0A
      ${order} %0d%0a Svp m'appeler au : < Votre numéro de Téléphone > %0D%0A Bonne journée,`;
      var mailto_link =
        "mailto:" + email + "?subject=" + subject + "&body=" + message;
      window.open(mailto_link, "emailWindow");
    },
    selectColor(colorIndex) {
      this.product.colors.map((el, i) => {
        if (colorIndex === i) {
          el.selected = true;
          this.selectedColor = el.name;
        } else {
          el.selected = false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/product.scss";
</style>
